import { FC } from "react";
import { styled } from "@mui/material/styles";
import ConnectWalletButton from "../../components/ConnectWallet";
import LandingLogo from "../../assets/LandingLogo.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const MainContainer = styled("div")(({ theme }) => ({
  width: "100%",
  padding: "10px 30px",

  [theme.breakpoints.down("smd")]: {
    padding: "10px",
    marginTop: "-50px",
  },
}));

const LandingHeading = styled("h1")(({ theme }) => ({
  fontSize: "40px",
  fontFamily: "Righteous",
  fontWeight: "800",
  color: theme.palette.primary.main,
}));

const LandingText = styled("h1")(({ theme }) => ({
  fontSize: "20px",
  fontFamily: "Poppins",
  fontWeight: "500",
  color: theme.palette.text.primary,
}));

const Landing: FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <MainContainer>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "ceter",
          justifyContent: "center",
          marginTop: "30px",
        }}
      >
        <div style={{ flex: "1", padding: "30px" }}>
          <LandingHeading>Decentralized Advertisement Protocol</LandingHeading>

          <LandingText style={{ marginTop: "20px" }}>
            As the Internet runs on Ads. Decentrads is a decentralized
            advertisement protocol that anyone can integrate on their dapp and
            start generating revenue from it like Google Ad sense in web2 but
            much less fee as compared to them providing them privacy,
            transparency, and full control of their deals. Decentrads provides
            applications and advertisers whole control by letting advertisers
            choose their platform to run ads on and what type of ads they want a
            platform to run with their given price, the application also has
            full control on selecting those ads that live to their values like
            ads that do not bother their platform users or to filters out bad
            products ( Unhealthy / Environmentally harmful / Frauds ).
          </LandingText>

          <div style={{ marginTop: "30px" }}>
            <ConnectWalletButton />
          </div>
        </div>

        {!isMobile ? (
          <div
            style={{
              flex: "1",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={LandingLogo}
              style={{ width: "500px" }}
              alt="Landing Logo"
            />
          </div>
        ) : null}
      </div>
    </MainContainer>
  );
};

export default Landing;
